import React from "react";
import {
  useLauncherState,
  requestLauncherToggle,
} from "../../../../app/components/KhubChatbot/chatbotLauncherBridge";
import "../../../../app/components/KhubChatbot/KhubChatbot.css";

// Topbar launcher for the KHub support chatbot — sits beside the bell icon.
// The actual chat panel + state live in <KhubChatbotWidget>; this is just the
// entry point, wired through chatbotLauncherBridge. It self-hides until the
// chatbot config is loaded (available), and shows an unread badge for incoming
// chats / messages / broadcasts while the panel is closed.
export function ChatbotHelpToggle() {
  const { available, isOpen, chatCount, broadcastCount, attention, brandColor } = useLauncherState();

  if (!available) return null;

  const fmt = (n) => (n > 9 ? "9+" : n);
  const counts = [];
  if (chatCount > 0) counts.push(`${chatCount} chat${chatCount > 1 ? "s" : ""}`);
  if (broadcastCount > 0) counts.push(`${broadcastCount} broadcast${broadcastCount > 1 ? "s" : ""}`);
  const label = counts.length
    ? `Help & Support — ${counts.join(", ")}`
    : isOpen
    ? "Close Help & Support"
    : "Help & Support";

  return (
    <div className="topbar-item">
      <button
        type="button"
        className={`btn btn-icon btn-clean btn-lg mr-1 khub-help-toggle${
          isOpen ? " khub-help-toggle--active" : ""
        }${!isOpen && attention ? " khub-help-toggle--attention" : ""}`}
        onClick={requestLauncherToggle}
        aria-label={label}
        title={label}
        style={isOpen ? { color: brandColor } : undefined}
      >
        <span className="khub-help-toggle-icon" aria-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </span>
        {/* Open chats — red badge, top-right */}
        {chatCount > 0 && (
          <span
            className="khub-help-toggle-badge khub-help-toggle-badge--chat"
            aria-label={`${chatCount} unread chats`}
            title={`${chatCount} unread chat${chatCount > 1 ? "s" : ""}`}
          >
            {fmt(chatCount)}
          </span>
        )}
        {/* Broadcasts — amber badge, top-left */}
        {broadcastCount > 0 && (
          <span
            className="khub-help-toggle-badge khub-help-toggle-badge--broadcast"
            aria-label={`${broadcastCount} new broadcasts`}
            title={`${broadcastCount} new broadcast${broadcastCount > 1 ? "s" : ""}`}
          >
            {fmt(broadcastCount)}
          </span>
        )}
      </button>
    </div>
  );
}
